<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card class="pa-3 ma-md-3">
            <v-toolbar flat color="#1d2735" dark>
                <v-icon class="white--text" style="font-size: 45px"
                    >mdi-account-supervisor-circle</v-icon
                >
                <pre><v-toolbar-title><h2>Informe</h2></v-toolbar-title></pre>
            </v-toolbar>
            <v-row style="margin-top: 1rem">
                <v-col cols="12" md="4"
                    ><date-select
                        v-model="fecha_inicio"
                        label="Fecha de inicio"
                    ></date-select
                ></v-col>
                <v-col cols="12" md="4"
                    ><date-select
                        v-model="fecha_fin"
                        label="Fecha de fin"
                    ></date-select
                ></v-col>

                <v-col cols="12" md="2"
                    ><v-btn
                        color="red"
                        class="white--text"
                        @click="
                            fecha_inicio = null;
                            fecha_fin = null;
                            agente = null;
                        "
                        >Limpiar</v-btn
                    >
                </v-col>

                <v-col cols="12" md="2"
                    ><v-btn color="primary" @click="getStats()">Filtrar</v-btn>
                </v-col>
            </v-row>
            <v-tabs v-model="tab">
                <v-tab>Resumen</v-tab>
                <v-tab-item>
                    <v-data-table
                        :headers="headers_agentes"
                        :items="resumen"
                        hide-default-footer
                        disable-pagination
                    ></v-data-table>
                </v-tab-item>
                <template v-for="(value, key, index) in semanas">
                    <v-tab>Semana {{ key }}</v-tab>
                    <v-tab-item>
                        <v-row style="padding-top: 1rem">
                            <v-col cols="6">
                                <v-text-field
                                    outlined
                                    label="Total presupuestado"
                                    v-model="value.total"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-data-table
                                    :items="value.semanas"
                                    :headers="headers"
                                >
                                    <template v-slot:item.m_obra="{ item }">
                                        <div
                                            :class="
                                                index < item.m_obra.length - 1
                                                    ? 'm_obra'
                                                    : ''
                                            "
                                            v-for="(
                                                m_obra, index
                                            ) in item.m_obra"
                                        >
                                            {{
                                                m_obra.tiempo | format_numero
                                            }}horas
                                        </div>
                                    </template>
                                    <template
                                        v-slot:item.m_obra_coste="{ item }"
                                    >
                                        <div
                                            :class="
                                                index < item.m_obra.length - 1
                                                    ? 'm_obra'
                                                    : ''
                                            "
                                            v-for="(
                                                m_obra, index
                                            ) in item.m_obra"
                                        >
                                            {{ m_obra.precio | format_numero }}€
                                        </div>
                                    </template>
                                    <template
                                        v-slot:item.m_obra_total="{ item }"
                                    >
                                        <div
                                            :class="
                                                index < item.m_obra.length - 1
                                                    ? 'm_obra'
                                                    : ''
                                            "
                                            v-for="(
                                                m_obra, index
                                            ) in item.m_obra"
                                        >
                                            {{ m_obra.total | format_numero }}€
                                        </div>
                                    </template>
                                    <template
                                        v-slot:item.m_obra_comidas="{ item }"
                                    >
                                        <div
                                            :class="
                                                index < item.m_obra.length - 1
                                                    ? 'm_obra'
                                                    : ''
                                            "
                                            v-for="(
                                                m_obra, index
                                            ) in item.m_obra"
                                        >
                                            {{ m_obra.comida | format_numero }}€
                                        </div>
                                    </template>
                                    <template
                                        v-slot:item.m_obra_desplazamiento="{
                                            item,
                                        }"
                                    >
                                        <div
                                            :class="
                                                index < item.m_obra.length - 1
                                                    ? 'm_obra'
                                                    : ''
                                            "
                                            v-for="(
                                                m_obra, index
                                            ) in item.m_obra"
                                        >
                                            {{
                                                m_obra.transporte
                                                    | format_numero
                                            }}€
                                        </div>
                                    </template>
                                    <template
                                        v-slot:item.m_obra_dietas="{ item }"
                                    >
                                        <div
                                            :class="
                                                index < item.m_obra.length - 1
                                                    ? 'm_obra'
                                                    : ''
                                            "
                                            v-for="(
                                                m_obra, index
                                            ) in item.m_obra"
                                        >
                                            {{
                                                m_obra.total_consumo
                                                    | format_numero
                                            }}€
                                        </div>
                                    </template>
                                    <template
                                        v-slot:item.horas_reales="{ item }"
                                    >
                                        {{ item.horas_reales | format_numero }}
                                    </template>
                                    <template
                                        v-slot:item.horas_presupuestadas="{
                                            item,
                                        }"
                                    >
                                        {{
                                            item.horas_presupuestadas
                                                | format_numero
                                        }}
                                    </template>
                                    <template
                                        v-slot:item.presupuesto="{ item }"
                                    >
                                        {{ item.presupuesto | format_precio }}
                                    </template>
                                    <template v-slot:item.semanas="{ item }">
                                        {{ item.semanas | format_numero }}
                                    </template>
                                    <template
                                        v-slot:item.coste_m_prima="{ item }"
                                    >
                                        {{ item.coste_m_prima | format_precio }}
                                    </template>
                                    <template
                                        v-slot:item.coste_total="{ item }"
                                    >
                                        {{ item.coste_total | format_precio }}
                                    </template>
                                    <template
                                        v-slot:item.resto_factura="{ item }"
                                    >
                                        {{ item.resto_factura | format_precio }}
                                    </template>
                                    <template
                                        v-slot:item.margen_bruto="{ item }"
                                    >
                                        {{ item.margen_bruto | format_precio }}
                                    </template>
                                    <template
                                        v-slot:item.per_margen_bruto="{ item }"
                                    >
                                        {{
                                            (item.per_margen_bruto * 100)
                                                | format_numero
                                        }}%
                                    </template>

                                    <template
                                        v-slot:item.pre_beneficio="{ item }"
                                    >
                                        {{
                                            (item.pre_beneficio * 100)
                                                | format_numero
                                        }}%
                                    </template>
                                    <template v-slot:item.beneficio="{ item }">
                                        {{ item.beneficio | format_precio }}
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </template>
            </v-tabs>
        </v-card>
    </v-container>
</template>
<style>
.m_obra {
    border-bottom: 1px solid #c7c7c7;
}
</style>
<script>
export default {
    components: {},
    data() {
        return {
            fecha_inicio: null,
            fecha_fin: null,
            tab: 0,
            semanas: [],
            agentes: [],
            resumen: [],
            headers_resumen: [
                { text: "Semana", value: "semana" },
                { text: "Presupuesto", value: "presupuesto" },
                { text: "Margen", value: "margen" },
                { text: "% Margen", value: "per_margen" },
                { text: "Estructura", value: "estructura" },
                { text: "", value: "m_est" },
            ],
            headers: [
                {
                    text: "Fecha de ejecución",
                    value: "fecha_ejecucion",
                },
                {
                    text: "Fecha de factura",
                    value: "fecha_factura",
                },
                {
                    text: "Semanas",
                    value: "semanas",
                },
                {
                    text: "Obra",
                    value: "orden",
                },
                {
                    text: "Comercial",
                    value: "comercial",
                },
                {
                    text: "Presupuesto",
                    value: "presupuesto",
                },
                {
                    text: "Producto",
                    value: "producto",
                },
                {
                    text: "Equipo",
                    value: "equipo",
                },
                {
                    text: "Horas presupuestadas",
                    value: "horas_presupuestadas",
                },
                {
                    text: "Horas reales",
                    value: "horas_reales",
                },
                {
                    text: "Dif. Horas",
                    value: "dif_horas",
                },
                {
                    text: "M. Obra",
                    value: "m_obra",
                },
                {
                    text: "Coste M. Obra+S.S.+I.R.P.F.",
                    value: "m_obra_coste",
                },
                {
                    text: "Total M. Obra+S.S.+I.R.P.F.",
                    value: "m_obra_total",
                },
                {
                    text: "Comidas",
                    value: "m_obra_comidas",
                },
                {
                    text: "Desplazamiento",
                    value: "m_obra_desplazamiento",
                },
                {
                    text: "Total M. Obra + Dietas",
                    value: "m_obra_dietas",
                },
                {
                    text: "Coste M. Prima",
                    value: "coste_m_prima",
                },
                {
                    text: "Coste M. Prima + M. Obra + Dietas",
                    value: "coste_total",
                },
                {
                    text: "Resto estructura sobre venta",
                    value: "resto_factura",
                },
                {
                    text: "Margen bruto",
                    value: "margen_bruto",
                },
                {
                    text: "% Margen bruto",
                    value: "per_margen_bruto",
                },
                {
                    text: "Estructura",
                    value: "estructura",
                },
                {
                    text: "% Beneficio real",
                    value: "pre_beneficio",
                },
                {
                    text: "Beneficio real",
                    value: "beneficio",
                },
            ],
        };
    },
    created() {
        this.getEstadisticas();
        this.getAgentes();
    },
    watch: {},
    methods: {
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.agentes = res.data.Agentes;
                },
                (err) => {
                    this.$custom_error("Error consultando los agentes");
                }
            );
        },
        getStats() {
            this.getEstadisticas();
        },
        getEstadisticas() {
            axios
                .get(`/api/ordenes/cierre?${this.getFechaRequest}`)
                .then((res) => {
                    this.semanas = res.data.semanas;
                    this.resumen = res.data.resumen;
                });
            //this.getComerciales();
        },
    },
    filters: {},

    computed: {
        isloading: function () {
            return this.$store.getters.getloading;
        },
        headers_agentes: function () {
            let headers = [...this.headers_resumen];
            this.agentes.forEach((agente) => {
                headers.push({
                    text: agente.nombre,
                    value: `com_${agente.id}`,
                });
            });
            headers.push({
                text: "Empresa",
                value: `com_empresa`,
            });
            headers.push({
                text: "Total",
                value: `total`,
            });

            return headers;
        },
        getFechaRequest() {
            let str = "";

            if (this.fecha_inicio != null) {
                str += `&fecha_inicio=${this.fecha_inicio}`;
            }
            if (this.fecha_fin != null) {
                str += `&fecha_fin=${this.fecha_fin}`;
            }

            return str;
        },
    },
};
</script>
